import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ItemProgressStep } from './model/item-progress-step.component';

@Component({
	selector: 'app-progress-steps-bar',
	templateUrl: './progress-steps-bar.component.html',
	styleUrls: ['./progress-steps-bar.component.scss']
})
export class ProgressStepsBarComponent implements OnChanges {
	@Input() items!: ItemProgressStep[];
	@Input() numberStep!: number;

	constructor() {
		this.items = [];
		this.numberStep = 1;
	}
	ngOnChanges(): void {
		if (this.items.length > 0) {
			// Se limpian todos los flag
			this.items.forEach((item) => {
				item.active = false;
			});

			// Se vuelven a activar los flags dependiendo del paso actual
			this.items.forEach((item, index) => {
				if (index < this.numberStep) {
					item.active = true;
				}
			});
		}
	}
}
